/**
 * Floral — Store Locator zero-results fallback.
 *
 * CONFIRMED 2026-07-08: the Stockist widget renders inside a Shadow DOM
 * (<stockist-store-locator>), so `widget.querySelectorAll(...)` from out here can NEVER
 * see into its result list — this isn't a wrong class name, it's a hard DOM boundary that
 * light-DOM queries cannot cross (see the shadow-DOM note in floral-store-locator.liquid).
 * There is no supported way, from this file, to detect the widget's real result count.
 * Rather than fabricate a callback that doesn't exist, this intentionally fails safe: the
 * MutationObserver below fires once the widget swaps its placeholder div for the shadow
 * host, but the count check underneath it can never resolve to "loaded with zero rows"
 * (both queries are always empty), so `zeroCard` simply stays hidden forever. That's a
 * known limitation, not a regression — it just means the designed zero-results card never
 * shows. Fixing it for real would require Stockist to expose a public event/API, or a
 * server-side lookup against their REST API; out of scope here.
 */
(function () {
  const widget = document.getElementById('floral-store-locator-widget');
  const zeroCard = document.querySelector('[data-locator-zero]');
  if (!widget || !zeroCard) return;

  let settleTimer = null;
  function evaluate() {
    const count = widget.querySelectorAll('.stockist-location-item').length;
    const hasLoaded = widget.querySelector('[class*="stockist-"]') !== null;
    zeroCard.hidden = !(hasLoaded && count === 0);
  }

  const observer = new MutationObserver(() => {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(evaluate, 400);
  });
  observer.observe(widget, { childList: true, subtree: true });

  // Klaviyo wiring for the "notify me" capture is a separate step pending Adam's named
  // approval (COPY_DECK.md pattern) — this is a no-op that just prevents a blank submit.
  const captureForm = document.querySelector('[data-locator-capture-form]');
  if (captureForm) {
    captureForm.addEventListener('submit', (e) => {
      e.preventDefault();
    });
  }
})();
